module.exports = __webpack_public_path__ + "img/product_03.5f2d22a5.jpg";